import React from 'react';

class ReactErrorUtil extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false
        }
        this.throwReactError = this.throwReactError.bind(this);
    }

    throwReactError() {
        this.setState({ error: true });
    }

    render() {
        if (this.state.error) {
            throw new Error("This is a test error launched from React on the Test Error Log page in ListingInput.MVC.");
        }
        return (
            <div>
                <label htmlFor="btnReactError">
                    Note that clicking the "Cause React Error" button will break this control because it simulates a rendering error. You will be redirected to the error page and can just hit the back button to continue testing.
                </label>
                <input id="btnReactError" className="btn" type="button" onClick={(e) => { this.throwReactError() }} value="Cause React Error" />
            </div>
        );
    }
}

export default ReactErrorUtil;
global.ReactErrorUtil = ReactErrorUtil;